import { hotRank } from "@/mocks/gossip";

export default function RankBoard() {
  const topThree = hotRank.slice(0, 3).map((r) => r.rank);
  return (
    <section id="rank" className="border-b border-foreground-950/10">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-16">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
          <div className="flex items-center gap-3">
            <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-primary-600 text-background-50">
              <i className="ri-fire-fill" />
            </span>
            <div>
              <h2 className="font-heading text-xl font-black tracking-tight text-foreground-950 md:text-2xl">热议人物榜 · 近 24h</h2>
              <p className="text-xs text-foreground-500">按热议指数排序，指数综合讨论量与信源活跃度</p>
            </div>
          </div>
          <span className="whitespace-nowrap rounded-full border border-foreground-950/15 px-3 py-1.5 text-xs text-foreground-600">更新于 09:45</span>
        </div>

        <ol className="divide-y divide-foreground-950/5 rounded-lg border border-foreground-950/10 bg-background-50">
          {hotRank.map((r) => {
            const isTop = topThree.includes(r.rank);
            const up = r.trend === "up";
            return (
              <li key={r.rank} className={`flex items-center gap-3 px-4 py-3 transition-colors hover:bg-background-100 md:gap-5 md:px-5 ${isTop ? "bg-primary-50/50" : ""}`}>
                <span
                  className={`w-7 shrink-0 text-center font-heading text-xl font-black md:w-9 md:text-2xl ${
                    isTop ? "text-primary-600" : "text-foreground-400"
                  }`}
                >
                  {r.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className={`whitespace-nowrap font-heading font-bold text-foreground-950 ${isTop ? "text-base md:text-lg" : "text-sm md:text-base"}`}>
                      {r.persona}
                    </h3>
                    {isTop && (
                      <span className="whitespace-nowrap rounded-sm bg-primary-600 px-1.5 py-0.5 text-[10px] font-medium text-background-50">热</span>
                    )}
                  </div>
                  <p className="mt-0.5 truncate text-xs text-foreground-600 md:text-sm">{r.tag}</p>
                </div>
                <div className="flex shrink-0 flex-col items-end">
                  <span className={`inline-flex items-center gap-1 text-xs font-semibold ${up ? "text-primary-600" : "text-accent-700"}`}>
                    <i className={up ? "ri-arrow-up-line" : "ri-arrow-down-line"} /> {r.delta}
                  </span>
                  <span className="font-label text-sm font-semibold text-foreground-900 md:text-base">{r.heat.toLocaleString()}</span>
                </div>
              </li>
            );
          })}
        </ol>

        <p className="mt-4 text-xs text-foreground-500">
          榜内人物均来自本站已建档的近期人物与背景档案，指数为当日快照，仅供参考。
        </p>
      </div>
    </section>
  );
}